import _extends from "@babel/runtime/helpers/extends";
import { Alert, Button, Form, Input, Spin } from "antd";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { IMPREZA_BUTTON_PROPS, _i, __ } from "../../../utils";
import { useStores } from "../../../store";
import { RealCommerceError } from "../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../hooks";
const AccountDetailsFormLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};
const AccountDetailsForm = observer(() => {
  const {
    accountStore: {
      session
    }
  } = useStores();
  const {
    busy,
    user: {
      email,
      firstName,
      lastName,
      unconfirmedEmail
    }
  } = session;
  const initialValues = {
    email,
    firstName,
    lastName
  };
  const [form] = Form.useForm();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const onFinish = useCallback(async _ref => {
    let {
      email,
      ...rest
    } = _ref;
    try {
      await session.updateDetails({
        ...rest,
        unconfirmedEmail: email
      });
    } catch (e) {
      if (e instanceof RealCommerceError) {
        handleRealCommerceError(e);
      }
    }
  }, [session]);
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement("p", null, __("The following personal data is stored for your account. You can change the data at any time and transfer your account to another email address.")), /*#__PURE__*/React.createElement(Form, _extends({
    form: form,
    onFinish: onFinish
  }, AccountDetailsFormLayout, {
    initialValues: initialValues,
    labelWrap: true
  }), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Email")
  }, /*#__PURE__*/React.createElement(Form.Item, {
    name: "email",
    rules: [{
      type: "email",
      required: true,
      message: __("Please enter a valid email address!")
    }],
    noStyle: true
  }, /*#__PURE__*/React.createElement(Input, null)), !!unconfirmedEmail && /*#__PURE__*/React.createElement(Alert, {
    style: {
      marginTop: 15
    },
    message: __("Confirm your new email address"),
    description: _i(__("You have requested to change your email address to {{strong}}%s{{/strong}}. Please check your inbox and follow the link to confirm the email.", unconfirmedEmail), {
      strong: /*#__PURE__*/React.createElement("strong", null)
    }),
    type: "success",
    showIcon: true
  })), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("First name"),
    name: "firstName",
    rules: [{
      required: true,
      message: __("Please enter your first name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Last name"),
    name: "lastName",
    rules: [{
      required: true,
      message: __("Please enter your last name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    wrapperCol: {
      offset: 6
    }
  }, /*#__PURE__*/React.createElement(Button, _extends({
    type: "primary",
    size: "large",
    htmlType: "submit"
  }, IMPREZA_BUTTON_PROPS), __("Save")))));
});
export { AccountDetailsForm };